import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import promo1 from "../../static/media/productos/Descuento_1.jpeg";
import promo2 from "../../static/media/productos/Descuento_2.jpeg";
import promo3 from "../../static/media/productos/Descuento_3.jpeg";
import promo4 from "../../static/media/productos/Descuento_4.jpeg";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  goldDark: "#E6B800",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const PROMOS = [
  { id: 1, img: promo1 },
  { id: 2, img: promo2 },
  { id: 3, img: promo3 },
  { id: 4, img: promo4 },
];

export default function Promociones() {
  return (
    <Box
      id="productos"
      sx={{
        background: C.white,
        pt: { xs: "100px", md: "120px" },
        pb: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1400px",
          mx: "auto",
          px: { xs: "20px", sm: "32px", md: "40px" },
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{ textAlign: "center", mb: { xs: 5, md: 7 } }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.dark,
              fontWeight: 900,
              fontSize: { xs: 26, sm: 32, md: 42 },
              letterSpacing: "-.02em",
              lineHeight: 1.1,
            }}
          >
            Nuestros Productos
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: { xs: "400px", sm: "500px", md: "80vh" },
            maxHeight: { md: "800px" },
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 12px 40px rgba(12,31,47,0.12)",
            border: "1px solid rgba(0,87,168,0.07)",
            background: C.gray,
          }}
        >
          <Swiper
            modules={[Autoplay, Pagination]}
            loop={true}
            slidesPerView={1}
            spaceBetween={0}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{ clickable: true }}
            style={{ width: "100%", height: "100%" }}
          >
            {PROMOS.map((promo) => (
              <SwiperSlide key={promo.id}>
                <Box
                  component="img"
                  src={promo.img}
                  alt={`Promoción ${promo.id}`}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: { xs: "cover", md: "contain" },
                    display: "block",
                    userSelect: "none",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Box>

      {/* Unión con Catalogos (azul) */}
      <Box
        sx={{
          height: { xs: "60px", md: "80px" },
          background: `linear-gradient(180deg, ${C.white} 0%, ${C.navy} 100%)`,
          mt: { xs: 7, md: 10 },
        }}
      />

      <style>{`
        .swiper { width: 100%; height: 100%; }
        .swiper-slide { display: flex; justify-content: center; align-items: center; }
        .swiper-pagination-bullet { width: 10px; height: 10px; background: rgba(255,255,255,0.7); opacity: 1; border-radius: 10px; transition: all 0.3s ease; box-shadow: 0 2px 6px #fff; margin: 0 5px !important; }
        .swiper-pagination-bullet:hover { background: #ffffff; }
        .swiper-pagination-bullet-active { width: 24px; background: ${C.gold}; }
        .swiper-pagination-bullets.swiper-pagination-horizontal { bottom: 20px !important; }
      `}</style>
    </Box>
  );
}
